import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { putJson } from 'utils/fetch';
import { hideLoader } from 'plugins/loader';
import Simulation from './Simulation';
import SchedulingModal from './SchedulingModal';
import { displayConfirmModalIfRequired } from 'plugins/confirm-action';
import moment from 'moment';

moment.locale('fr');

function handleInvoiceChoice($form) {
  const $invoice = $form.find('div.invoice');
  const $frequency = $invoice.find('input[name=invoice_frequency]');
  const $buttons = $invoice.find('button');

  $buttons.each(function() {
    const button = $(this);
    button.on('click', evt => {
      evt.preventDefault();
      $frequency.val(button.val());
      $buttons.removeClass('active');
      button.addClass('active');
    });
  });
}

function handleAutomaticInvoiceCheckbox($form) {
  const $invoice = $form.find('div.invoice');
  const $checkbox = $form.find('#automatic_invoice_enabled');
  const $byIntervention = $invoice.find('button[value=INTERVENTION]');
  const $oneShot = $invoice.find('button[value=ONESHOT]');

  $checkbox.on('change', evt => {
    evt.preventDefault();
    if ($checkbox.is(':checked')) {
      $checkbox.val('true');
      $byIntervention.attr('disabled', 'disabled');
      if ($byIntervention.hasClass('active')) {
        $byIntervention.removeClass('active');
        $oneShot.trigger('click');
      }
    } else {
      $checkbox.val('false');
      $byIntervention.removeAttr('disabled');
    }
  });

  if ($checkbox.val() === 'true') {
    $byIntervention.attr('disabled', 'disabled');
  } else {
    $byIntervention.removeAttr('disabled');
  }
}

let nextAction;

const handleButtonSimulation = () => {
  $('#runSimulation').on('click', evt => {
    const $button = $(evt.target);
    const action = $button.attr('data-action');

    nextAction = action;

    return true;
  });
};

function handleForm($form) {
  $form.on('submit', evt => {
    const $button = $(document.activeElement);
    const action = $button.attr('data-action') || nextAction;

    nextAction = null;

    if (action) {
      evt.preventDefault();

      const $form = $(evt.currentTarget);
      const data = {};

      for (let prop of $form.serializeArray()) {
        data[prop.name] = prop.value;
      }

      putJson(action, JSON.stringify(data)).then(
        res => {
          hideLoader();
          const line = ReactDOMServer.renderToStaticMarkup(
            <Simulation data={res} invoiceDate={data.invoice_date} />
          );
          $('#simulation').html(line);
        },
        err => {
          hideLoader();
          console.log(err);
          $('#simulation').html('');
        }
      );
    }
  });
}

function initCustomFrequency(
  buttonSelector,
  divSelector,
  inputSelector,
  title
) {
  const $button = $(buttonSelector);
  const $div = $button.closest(divSelector);
  const $input = $div.find(inputSelector);

  const root = document.getElementById('custom-frequency-root');

  const onModalClosed = () => ReactDOM.unmountComponentAtNode(root);

  const onSelectionSaved = selection => {
    onModalClosed();

    if (selection) {
      const result = selection
        .map(e => e.date)
        .reduce(function(a, b) {
          return a + ',' + b;
        }, '');
      $input.val(result);
    } else {
    }
  };

  const startMonth = moment().startOf('month');

  const startScope = startMonth.startOf('isoweek').isSame(startMonth, 'month')
    ? startMonth.startOf('isoweek')
    : startMonth.startOf('isoweek').plus(1, 'isoweek');

  const endScope = moment()
    .day('Monday')
    .startOf('month')
    .add(1, 'year')
    .endOf('month');

  if ($input.val().length > 0) {
    const initialValue = $input.val().split(',');

    const scoped = initialValue
      .filter(date =>
        moment(date, 'DD/MM/YYYY').isBetween(startScope, endScope)
      )
      .reduce(function(a, b) {
        return a + ',' + b;
      }, '');

    $input.val(scoped);
  }

  $button.on('click', evt => {
    evt.preventDefault();
    let value = [];

    //With empty initial value
    if ($input.val().length > 0) {
      value = $input.val().split(',');
    }

    // Rendering scheduling modal
    ReactDOM.render(
      <SchedulingModal
        title={title}
        value={value}
        onSaved={onSelectionSaved}
        onClosed={onModalClosed}
      />,
      root
    );
  });
}

function handleEstimateSelectionChange($form) {
  const $dropdown = $form.find('select[name=estimate_reference]');
  const lastEstimateInfo = $form.find('.lastEstimateInfo');
  const estimateInfos = $form.find('.estimateInfo');

  $dropdown.on('change', evt => {
    const $select = evt.target;
    const currentValue = $select.options[$select.selectedIndex].value;

    lastEstimateInfo.hide();
    estimateInfos.hide();

    const $estimateToShow = estimateInfos.filter(
      (index, element) => !element.dataset.id.localeCompare(currentValue)
    );
    $estimateToShow.show();
  });
}

export const edit = () => {
  const $form = $('form');
  handleInvoiceChoice($form);
  handleAutomaticInvoiceCheckbox($form);
  initCustomFrequency(
    'button.modalInvoicePickerPlanification',
    'div.invoice',
    'input[name=invoice_custom_frequency]',
    'Frequence de facturation'
  );
  handleEstimateSelectionChange($form);

  const $button = $('button[data-id=save-organize]');
  $button.on('click', evt => {
    evt.preventDefault();
    // Handling confirm action modal
    displayConfirmModalIfRequired($button, () => $form.submit());
  });

  handleForm($form);
  handleButtonSimulation();
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/forced-invoices-organize/index.js